// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import '@babel/polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import store from 'store'
import { apiInterface, httpRequest, type, data } from 'api'
import ElementUI from 'element-ui'

import './assets/theme/index.css' // 引入Element组件主题颜色
import './assets/iconfont/iconfont.css' // 引入Element组件主题字体
import './styles/index.scss'

Vue.use(ElementUI, {size: 'small'})

Vue.prototype.$globalConfig = window.config
Vue.prototype.$message = ElementUI.Message
Vue.prototype.$messagebox = ElementUI.MessageBox
Vue.prototype.$api = apiInterface
Vue.prototype.$http = httpRequest
Vue.prototype.$type = type
Vue.prototype.$globalData = data

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js